const options = [
  {
    letter: 'A',
    title: 'Unlimited dial-back only',
    desc: 'Jessica joins, holds your seat, calls you in. Nothing recorded, nothing summarized. Pure presence. Already available at $49/month.',
  },
  {
    letter: 'B',
    title: 'Dial-back + meeting summary notes',
    desc: 'Everything in A, plus a written debrief delivered to your inbox after every call ends. Pricing TBD based on your input.',
  },
  {
    letter: 'C',
    title: 'Dial-back + meeting summary + full recording',
    desc: 'Everything in B, plus the complete audio record — captured from minute one, before you even picked up. Pricing TBD based on your input.',
  },
];

const meetingQs = [
  'How many meetings do you have in a typical week?',
  'How long do they usually run — 30 minutes, an hour, longer?',
];

export default function DialBackBeta() {
  return (
    <section
      id="beta"
      className="py-28 px-12 border-t border-[rgba(200,71,42,0.15)] max-md:px-6 max-md:py-20"
      style={{ background: 'rgba(200,71,42,0.05)', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div className="max-w-[860px] mx-auto">
        <div
          className="flex items-center gap-3 mb-4"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8472a' }}
        >
          <span className="block w-6 h-px bg-[#c8472a]" />
          Help us build this right
        </div>

        <h2
          className="font-light leading-[1.1] text-[#f5f2ec] mb-3"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}
        >
          Which plan works<br />
          <em className="italic text-[#9a9488]">best for you?</em>
        </h2>

        <p className="text-[1rem] text-[rgba(245,242,236,0.65)] leading-[1.7] mb-12 max-w-[600px]">
          We&apos;re setting pricing for the full feature set based on how real people actually use meetings. Answer two quick questions and tell us which option fits your week — and we&apos;ll build pricing that&apos;s actually fair.
        </p>

        {/* Options */}
        <div className="flex flex-col gap-[1px] mb-10">
          {options.map((opt) => (
            <div
              key={opt.letter}
              className="flex items-start gap-4 px-6 py-5 bg-white/[0.02] border border-white/[0.06] rounded-[3px] transition-all duration-200 hover:bg-white/[0.04] hover:border-white/[0.1] cursor-default"
            >
              <div
                className="text-[#c8472a] min-w-[20px] pt-[2px]"
                style={{ fontFamily: "'DM Mono', monospace", fontSize: '12px', fontWeight: 500 }}
              >
                {opt.letter}
              </div>
              <div>
                <div className="font-semibold text-[0.95rem] text-[#f5f2ec] mb-1">{opt.title}</div>
                <div className="text-[0.85rem] text-[rgba(245,242,236,0.55)] leading-[1.5]">{opt.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Meeting Qs */}
        <div className="bg-white/[0.02] border border-white/[0.07] rounded-[3px] p-6 mb-8">
          <div
            className="mb-4 text-[#9a9488]"
            style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', letterSpacing: '0.16em', textTransform: 'uppercase' }}
          >
            Two quick questions to help us price it right
          </div>
          {meetingQs.map((q, i) => (
            <div
              key={i}
              className="flex items-start gap-3 py-[10px] border-b border-white/[0.04] last:border-b-0 text-[0.92rem] text-[rgba(245,242,236,0.75)]"
            >
              <span
                className="text-[#c8472a] pt-[2px]"
                style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px' }}
              >
                0{i + 1}
              </span>
              {q}
            </div>
          ))}
        </div>

        <p className="text-[0.95rem] text-[rgba(245,242,236,0.65)] leading-[1.7] mb-8">
          Drop A, B, or C in the comments on LinkedIn — along with your weekly meeting count and average length. I&apos;ll use those numbers to build pricing that&apos;s genuinely fair, and I&apos;ll make beta access super affordable for the people who help shape it.
        </p>

        <div className="flex gap-4 flex-wrap">
          <a
            href="https://www.linkedin.com/posts/petergits_its-905-am-the-meeting-started-five-minutes-activity-7445455146685255680-foCp?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABacG8B2S0Wl80pkWQ6ldVyN_dPahyhizY"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-[13px] font-semibold tracking-[0.1em] uppercase text-[#0e0d0b] bg-[#f5f2ec] px-8 py-4 rounded-sm no-underline transition-all duration-200 hover:bg-[#c8472a] hover:text-[#f5f2ec] hover:-translate-y-px whitespace-nowrap cursor-pointer"
          >
            Comment on LinkedIn
          </a>
          <a
            href="https://www.linkedin.com/posts/petergits_its-905-am-the-meeting-started-five-minutes-activity-7445455146685255680-foCp?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABacG8B2S0Wl80pkWQ6ldVyN_dPahyhizY"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-[13px] font-semibold tracking-[0.08em] uppercase text-[#f5f2ec] bg-transparent border border-white/20 px-7 py-4 rounded-sm no-underline transition-all duration-200 hover:border-white/60 hover:bg-white/5 whitespace-nowrap cursor-pointer"
          >
            Like the post to get pinged
          </a>
        </div>
      </div>
    </section>
  );
}
